import { OrganizationRole } from 'src/context/types';

/** Fixed section order. Record sections (Phase 2) append after these. */
export const SECTION_ORDER = ['pages', 'actions', 'settings'] as const;

export type LocalSectionId = (typeof SECTION_ORDER)[number];

/** A record section is identified by its SearchResultType, e.g. 'order'. */
export type PaletteSectionId = LocalSectionId | (string & {});

export interface PaletteItem {
  /** Stable DOM id; must be unique across every section. */
  id: string;
  section: PaletteSectionId;
  /** Resolved, human-readable label. Registries store i18n keys; the hook resolves them. */
  label: string;
  sublabel?: string;
  /** Leaf path for buildPath(). Present on navigable items only. */
  path?: string;
  /** Query params appended to `path` on activation. Record items only. */
  params?: Record<string, string>;
  /** Present on action items only. */
  run?: () => void;
  score: number;
}

export interface PaletteSection {
  id: PaletteSectionId;
  /** Resolved section heading. Local sections leave this unset and the modal falls back
   *  to `t('globalSearch.sections.<id>')`. */
  title?: string;
  items: PaletteItem[];
}

export interface RoleGated {
  roles: OrganizationRole[];
}
